import { Component, HostBinding, Input } from '@angular/core';
import { SphereSkeletonComponent } from '../skeleton/skeleton.component';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'sphere-shell-full-page-loading-placeholder',
    templateUrl: './full-page-loading-placeholder.component.html',
    styleUrls: ['./full-page-loading-placeholder.component.scss'],
    imports: [SphereSkeletonComponent, NgTemplateOutlet]
})
export class FullPageLoadingPlaceholderComponent {
    @Input()
    @HostBinding('style.backgroundColor')
    public backgroundColor = '#303030';
}
